/**
 * skProperty directive, used for working with properties on the FBS multi-property mobile screens
 */
bookingApp.directive('skProperty', function(){
    return {
        scope: {
            name: "=",
            availability: "=?",
            rating: "=?",
            description: "=?",
            promoText: "=?",
            pricingFrom: "=?",
            propertyId: "=?",
            unformatedPricingFrom: "=?",
            region: "=?",
            photo: "=?"
        },
        template: '<div class="property prop-{{propertyId}}">' +
            '<div class="marketing-name text-center">' +
                '<div class="container-fluid">' +
                    '<div class="col-xs-12">' +
                        '<h2><strong>{{name}}</strong></h2>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div>' +
                '<div class="property-thumbnail"></div>' +
            '</div>' +
            '<div class="property-info">' +
                '<div class="property-pricing container-fluid">' +
                    '<div class="price text-center formatted-price col-xs-12">' +
                        '<span class="region">{{region}}</span>' +
                        '<span class="price-from">' +
                            '<span ng-if="region && region.length < 40"> | </span>' +
                            '<br ng-if="region && region.length > 40"/>' +
                            'From: ' +
                            '<strong>{{pricingFrom}}</strong>' +
                        '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="property-blurb col-xs-12 text-center">' +
                    '<div class="badges">' +
                        '<span class="badge availability" ng-class="{\'available\': availability === 2, \'on-request\': availability === 1, \'unavailable\': availability === 0}">' +
                            '<span ng-if="availability === 0"><span class="glyphicon glyphicon-remove"></span> Unavailable</span>' +
                            '<span ng-if="availability === 1"><span class="glyphicon glyphicon-bell"></span> On Request</span>' +
                            '<span ng-if="availability === 2"><span class="glyphicon glyphicon-ok"></span> Available</span>' +
                        '</span>' +
                        '<span class="badge rating" ng-if="rating">' +
                            '<span class="glyphicon glyphicon-star"></span> {{rating}}' +
                        '</span>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="property-promo-text container-fluid" ng-if="promoText">' +
                '<span ng-bind-html="promoText"></span>' +
            '</div>' +
            '<div class="property-description container-fluid">' +
                '<span ng-bind-html="description | limitTo:200"></span><span class="ellipsis" ng-if="description.length > 200">...</span>' +
            '</div>' +
        '</div>',
        link: function(scope, element, attrs){
            // property photo shower
            if(scope.photo) {
                element.find('.property-thumbnail').css('background-image', 'url(' + scope.photo + ')');
            } else {
                element.find('.property-thumbnail').hide();
            }
            // priceFromShower
            if(parseInt(scope.unformatedPricingFrom) <= 0){
                element.find('.price-from').hide();
            }
        }
    };
});
